import React from 'react';

import { showFrontChat } from 'services/front_chat';
import { useAccount } from 'hooks/api/useAccount';
import { useAPI } from 'hooks/api/useAPI';
import { useCurrentOrganization } from 'hooks/api/useCurrentOrganization';

export function useShowFrontChatWithIdentity() {
  const { applicationID } = useAPI();
  const { data: organization } = useCurrentOrganization();
  const { data: account } = useAccount();

  const organizationId = organization?.id;

  const roles = account?.roles
    .filter(
      ({ application_id, organization_id }) =>
        application_id === applicationID || organization_id === organizationId
    )
    .map(({ name }) => name)
    ?.join(',');

  const showFrontChatWithIdentity = React.useCallback(() => {
    showFrontChat({
      'Application ID': applicationID,
      'Organization ID': organizationId,
      Roles: roles,
    });
  }, [applicationID, organizationId, roles]);

  React.useEffect(() => {
    (window as any).lumeo.showMessenger = showFrontChatWithIdentity;
  }, [showFrontChatWithIdentity]);

  return showFrontChatWithIdentity;
}
